module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-rg-hover.5673b0ce935ee528940783b5896c9602.png";